import { createUseStyles } from 'react-jss'
import { black } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  details: {
    marginTop: [0, '!important'],
    color: [black, '!important']
  }
})

export default useStyles
